import { createAction } from "redux-act";

export const changeTheme = createAction("Change theme");
export const setDetails = createAction("Set details");
export const setOtherAccount = createAction("Set other account");
export const clearDetails = createAction("Clear details");
